import { render, staticRenderFns } from "./SubscriptionChoice.vue?vue&type=template&id=186ca701&"
import script from "./SubscriptionChoice.vue?vue&type=script&lang=js&"
export * from "./SubscriptionChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports